import { CRM_SIGNUP, MARKETING_SIGNUP, SALES_SIGNUP, SERVICE_SIGNUP, CMS_FREE_SIGNUP } from 'growth-onboarding-signup-redirect/constants/signupConstants';
import { Flow } from 'signup-constants/Flow';
import { Integration } from 'signup-constants/Integration';
import { getFlowKey } from '../routing/getFlowKey';
import { getIntegrationKey } from '../routing/getIntegrationKey';
export const FlowOnboardingSignup = new Map([[Flow.Marketing, MARKETING_SIGNUP], [Flow.Crm, CRM_SIGNUP], [Flow.Sales, SALES_SIGNUP], [Flow.Service, SERVICE_SIGNUP], [Flow.CmsFree, CMS_FREE_SIGNUP], [Flow.HubspotForStartups, SALES_SIGNUP], [Integration.DesignKitGenerator, CMS_FREE_SIGNUP]]);
export const getRedirectSignupType = () => {
  const flowKey = getFlowKey();
  const integrationKey = getIntegrationKey();
  const key = flowKey === Flow.Integrations && integrationKey ? integrationKey : flowKey;
  return FlowOnboardingSignup.get(key) || FlowOnboardingSignup.get(Flow.Crm);
};